import React from 'react';
import PropTypes from 'prop-types';

import ActionMediaContainerWrapper from './ActionMediaContainer.style';

const ActionMediaContainer = ({ children }) => (
  <ActionMediaContainerWrapper>
    {children}
  </ActionMediaContainerWrapper>
);

ActionMediaContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]).isRequired
};

export default ActionMediaContainer;
